import { feature as dataPushServiceFeature } from '@central-products/data-push-service';

export const dataPushServicePlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    addBootstrapperFeature(dataPushServiceFeature, params);
  },
};
